import React from 'react'
import { useLocation } from 'react-router-dom';
import ExpertQA from '../../NewComponent/answerBox/ExpertQA/index';
import DocQA from '../../NewComponent/answerBox/docQA/index';

export default function ExpertData({data}) {
  return (
    <div>
      {data.map((que) => {
              if(que.confidence===false && que.docType==='expertqa'){
                return (
                  <ExpertQA
                  key={que.questionUuid}
                    question={que}
                    data={que.answers}
                  />
                );
              } 
              if(que.confidence===false && que.docType !=='expertqa'){
                return (
                <DocQA
                key={que.questionUuid}
                  question={que}
                  data={que.answers[0]}
                />
              );
              }
             
          })}
    </div>
  )
}
